// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"12098c30","453":"9e42a7e6","876":"ca2ecd35"}[chunkId] + ".chunk.js";
};